/**
 * 
 * This is a auto-generated file. Do not edit this manually.
 * To add new icon add the svg file to the app/images/icons folder 
 * and run 'npm run generate-icons' to generate this file.
 * 
 * */

import { ReactComponent as blockquote} from '../../images/icons/blockquote.svg';
import { ReactComponent as bulletList} from '../../images/icons/bulletList.svg';
import { ReactComponent as caretDown} from '../../images/icons/caretDown.svg';
import { ReactComponent as caretUp} from '../../images/icons/caretUp.svg';
import { ReactComponent as checkmarkFilled} from '../../images/icons/checkmarkFilled.svg';
import { ReactComponent as checkmarkOutline} from '../../images/icons/checkmarkOutline.svg';
import { ReactComponent as code} from '../../images/icons/code.svg';
import { ReactComponent as codeBlock} from '../../images/icons/codeBlock.svg';
import { ReactComponent as collapse} from '../../images/icons/collapse.svg';
import { ReactComponent as done} from '../../images/icons/done.svg';
import { ReactComponent as download} from '../../images/icons/download.svg';
import { ReactComponent as drag} from '../../images/icons/drag.svg';
import { ReactComponent as expand} from '../../images/icons/expand.svg';
import { ReactComponent as facebook} from '../../images/icons/facebook.svg';
import { ReactComponent as feedback} from '../../images/icons/feedback.svg';
import { ReactComponent as github} from '../../images/icons/github.svg';
import { ReactComponent as image} from '../../images/icons/image.svg';
import { ReactComponent as instagram} from '../../images/icons/instagram.svg';
import { ReactComponent as link} from '../../images/icons/link.svg';
import { ReactComponent as logo} from '../../images/icons/logo.svg';
import { ReactComponent as markdown} from '../../images/icons/markdown.svg';
import { ReactComponent as minus} from '../../images/icons/minus.svg';
import { ReactComponent as orderedList} from '../../images/icons/orderedList.svg';
import { ReactComponent as partyPopper} from '../../images/icons/partyPopper.svg';
import { ReactComponent as pause} from '../../images/icons/pause.svg';
import { ReactComponent as pencil} from '../../images/icons/pencil.svg';
import { ReactComponent as peopleNearby} from '../../images/icons/peopleNearby.svg';
import { ReactComponent as play} from '../../images/icons/play.svg';
import { ReactComponent as playCircle} from '../../images/icons/playCircle.svg';
import { ReactComponent as plus} from '../../images/icons/plus.svg';
import { ReactComponent as preview} from '../../images/icons/preview.svg';
import { ReactComponent as publish} from '../../images/icons/publish.svg';
import { ReactComponent as quiz_1} from '../../images/icons/quiz_1.svg';
import { ReactComponent as quiz_10} from '../../images/icons/quiz_10.svg';
import { ReactComponent as quiz_11} from '../../images/icons/quiz_11.svg';
import { ReactComponent as quiz_12} from '../../images/icons/quiz_12.svg';
import { ReactComponent as quiz_13} from '../../images/icons/quiz_13.svg';
import { ReactComponent as quiz_2} from '../../images/icons/quiz_2.svg';
import { ReactComponent as quiz_3} from '../../images/icons/quiz_3.svg';
import { ReactComponent as quiz_4} from '../../images/icons/quiz_4.svg';
import { ReactComponent as quiz_5} from '../../images/icons/quiz_5.svg';
import { ReactComponent as quiz_6} from '../../images/icons/quiz_6.svg';
import { ReactComponent as quiz_7} from '../../images/icons/quiz_7.svg';
import { ReactComponent as quiz_8} from '../../images/icons/quiz_8.svg';
import { ReactComponent as quiz_9} from '../../images/icons/quiz_9.svg';
import { ReactComponent as randomTeam} from '../../images/icons/randomTeam.svg';
import { ReactComponent as rating} from '../../images/icons/rating.svg';
import { ReactComponent as search} from '../../images/icons/search.svg';
import { ReactComponent as settingsWheels} from '../../images/icons/settingsWheels.svg';
import { ReactComponent as sort} from '../../images/icons/sort.svg';
import { ReactComponent as team} from '../../images/icons/team.svg';
import { ReactComponent as trash} from '../../images/icons/trash.svg';
import { ReactComponent as twitter} from '../../images/icons/twitter.svg';
import { ReactComponent as videoCamera} from '../../images/icons/videoCamera.svg';
import { ReactComponent as youtube} from '../../images/icons/youtube.svg';

/* eslint-disable @typescript-eslint/naming-convention */
const icons = {
  blockquote,
  bulletList,
  caretDown,
  caretUp,
  checkmarkFilled,
  checkmarkOutline,
  code,
  codeBlock,
  collapse,
  done,
  download,
  drag,
  expand,
  facebook,
  feedback,
  github,
  image,
  instagram,
  link,
  logo,
  markdown,
  minus,
  orderedList,
  partyPopper,
  pause,
  pencil,
  peopleNearby,
  play,
  playCircle,
  plus,
  preview,
  publish,
  quiz_1,
  quiz_10,
  quiz_11,
  quiz_12,
  quiz_13,
  quiz_2,
  quiz_3,
  quiz_4,
  quiz_5,
  quiz_6,
  quiz_7,
  quiz_8,
  quiz_9,
  randomTeam,
  rating,
  search,
  settingsWheels,
  sort,
  team,
  trash,
  twitter,
  videoCamera,
  youtube,
};

export default icons;